export default __webpack_public_path__ + "static/media/chevron--left.aa6e0e6d.svg";